import React, { useEffect, useState } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Switch } from './ui/switch';
import { MessageSquareText } from 'lucide-react';
import { api } from '../lib/api';
import { toast } from 'sonner';

export const SmsSettings = () => {
  const [pref, setPref] = useState(null);
  const [phone, setPhone] = useState('');
  const [optIn, setOptIn] = useState(false);

  useEffect(() => { api.get('/me/sms').then(({ data }) => { setPref(data); setPhone(data.phone || ''); setOptIn(data.sms_opt_in); }).catch(() => {}); }, []);
  if (!pref) return null;

  const save = async () => {
    try {
      const { data } = await api.post('/me/sms', { phone, sms_opt_in: optIn });
      setPref(data); setPhone(data.phone || '');
      toast.success(optIn ? (data.provider_enabled ? 'Text reminders on' : 'Saved — you\u2019ll be first in line when texting goes live') : 'Text reminders off');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not save'); }
  };

  return (
    <Card className="p-5 mb-8 bg-card" data-testid="sms-settings">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
        <div className="flex-1">
          <div className="font-semibold flex items-center gap-2" style={{fontFamily: 'Lexend'}}><MessageSquareText className="w-4 h-4 text-primary" /> Text-message reminders
            {!pref.provider_enabled && <span className="text-[10px] font-semibold uppercase tracking-wide bg-[#FFF4E5] text-[#663C00] border border-[#FFE0B2] rounded-full px-2 py-0.5" data-testid="sms-coming-soon">Coming soon</span>}
          </div>
          <p className="text-sm text-muted-foreground mt-1">{pref.provider_enabled ? 'Get a text when an ID is about to expire or a target date is a week away. Canadian mobile numbers only; standard rates may apply.' : 'Texting isn\u2019t switched on yet. Add your number now and reminders will start automatically the day it goes live — email reminders keep working meanwhile.'}</p>
        </div>
        <div className="flex items-center gap-3">
          <Input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="416 555 0123" className="h-11 w-40" aria-label="Mobile number" data-testid="sms-phone" />
          <div className="flex items-center gap-2"><Switch id="sms-opt" checked={optIn} onCheckedChange={setOptIn} data-testid="sms-opt-in" /><label htmlFor="sms-opt" className="text-sm font-medium">On</label></div>
          <Button onClick={save} className="h-11 bg-primary hover:bg-primary/90 text-primary-foreground" data-testid="sms-save">Save</Button>
        </div>
      </div>
    </Card>
  );
};
